import React from "react";
import "./Fold.scss";
import andImage from "./images/and.svg";
import topRightImage from "./images/top-fold.webp";
import rightImage from "./images/right-fold.webp";
import leftImage from "./images/grozde-1.webp";
import mainImage from "./images/main-image.webp";
import bgFold from "./images/bg-fold.webp";

function Fold({ t }) {
  return (
    <div className="flex flex-align-center relative fold">
      <div className="flex col-12 flex-justify-end p-2 p-1-xs p-1-sm content-fold">
        <a href="#confirm" className="confirm-btn btn-fold-mobile">
          <i className="fa-solid fa-calendar-check m-right-1"></i>
          {t.confirmBtn} <span className="hidden-xsm">{t.confirmBtnMobile}</span>
        </a>
      </div>
      <div className="btn-image">
        <img
          width={"100%"}
          height={"auto"}
          src={topRightImage}
        ></img>
      </div>

      <img
        className="left-image"
        width={"100%"}
        height={"auto"}
        src={leftImage}
      ></img>

      <img
        className="right-image"
        width={"100%"}
        height={"auto"}
        src={rightImage}
      ></img>
      {/* <div className="col-12 hidden-lg hidden-xl bg-secondary text-center p-inline-1 p-block-2 mobile-header ">
        <div className="flex flex-align-center flex-justify-center full-width">
          <h6>НЕЛИ</h6>
          <h6 className="p-inline-1">и</h6>
          <h6>АНГЕЛ</h6>
        </div>
      </div> */}
      <div className="relative fold-container">
        <div className="flex flex-align-center flex-justify-center flex-justify-space-between-mxl p-bottom-4-mxl p-inline-6-xl">
          <div className="relative col-5 col-12-xs col-12-sm col-12-md col-12-lg text-center p-top-12-mxl p-top-8-sm p-top-4-xs content-fold p-inline-1-xsm relative m-top-8-md">
            <img
              className="bottom-image"
              width={"100%"}
              height={"auto"}
              src={rightImage}
            ></img>
            <div className="m-bottom-1 m-top-2">{t.dearGuests}</div>
            <div className="m-bottom-4">{t.we}</div>
            <h1 className="names-fontsize">{t.brideName}</h1>
            <div className="col-6 m-inline-auto">
              <img
                className="fold-and-image"
                width={"100%"}
                height={"auto"}
                src={andImage}
                alt="and"
              >
              </img>
            </div>
            <h1 className="names-fontsize">{t.groomName}</h1>
            <div className="col-9 col-12-xs col-12-sm col-12-md col-12-lg m-inline-auto m-top-4 p-inline-6-sm p-inline-no-xsm text-justify text-center p-inline-12-md p-inline-12-lg m-inline-12-lg">
              <div>{t.invitationLead}<span className="font-weight-700 text-border">{t.invitationYes}</span>{t.invitationAfterYes}<br /> {t.invitationQuestion}</div><div className="m-top-1">{t.invitationCelebrate}<br className="" /></div>{t.invitationWithYou}
            </div>
            <h2 className="m-top-3 m-bottom-1 font-body custom-date-font-size m-bottom-12-mxl"><span className="font-body">{t.day}</span> {t.month}, <span className="font-body">{t.year}</span></h2>
          </div>
          <div className="col-6 col-12-xs col-12-sm col-12-md col-12-lg animation-fade-in animation-delay-3s animation-duration-1s opacity-0 p-left-12-xl p-top-12-xl m-top-10-xl">

            <div className="main-image relative">
              <img
                width={"100%"}
                height={"auto"}
                className="main-image-shadow"
                src={mainImage}
              ></img>
              <img
                className="bg-fold hidden-xsm"
                width={"100%"}
                height={"auto"}
                src={bgFold}
              ></img>
              <div className="text-center text-xs p-top-1 p-bottom-3 letter-spacing-2px">
                <div>{t.villaLocation}</div>
                <div>{t.country}</div>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* <img
          className="bg-fold"
          width={"100%"}
          height={"auto"}
          src={bgFold}
        ></img>
      <img
          className="right-image"
          width={"100%"}
          height={"auto"}
          src={rightImage}
        ></img> */}
    </div>
  );
}

export default Fold;
